import type { RawRow } from "../types";

/** 空欄として扱う値の集合 (`#N/A` / `None` は Excel の数式エラー / 文字列化された Python None) */
export const EMPTY_SENTINELS: ReadonlySet<string> = new Set(["", "#N/A", "None"]);

/** セルを正規化文字列化。null / undefined は `""`、それ以外は trim 済み string。 */
export function cellText(cell: string | null | undefined): string {
  if (cell === null || cell === undefined) return "";
  return String(cell).trim();
}

/** `EMPTY_SENTINELS` に含まれない実値かを判定。 */
export function isMeaningful(value: string): boolean {
  return !EMPTY_SENTINELS.has(value);
}

/** 行を ヘッダー名 → セル文字列 の object に整形。 */
export function rowMap(header: string[], row: RawRow): Record<string, string> {
  const m: Record<string, string> = {};
  for (let i = 0; i < header.length; i++) {
    const key = header[i];
    if (!key) continue;
    m[key] = cellText(row[i]);
  }
  return m;
}
